import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.825,5.625,6.262,7.858a.624.624,0,0,1-.512.267q-.03,0-.06,0a.624.624,0,0,1-.511-.368L3.735,4.505a.251.251,0,0,0-.417-.063l-.848.97A.625.625,0,0,1,2,5.625H.25a.25.25,0,0,0-.25.25V8.5A1.5,1.5,0,0,0,1.5,10h7A1.5,1.5,0,0,0,10,8.5V5.875a.25.25,0,0,0-.25-.25Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.716,4.375,3.28,2.588a.637.637,0,0,1,.564-.206.624.624,0,0,1,.477.364L5.692,5.832a.25.25,0,0,0,.434.041l.862-1.231A.626.626,0,0,1,7.5,4.375H9.75a.25.25,0,0,0,.25-.25V1.5A1.5,1.5,0,0,0,8.5,0h-7A1.5,1.5,0,0,0,0,1.5V4.125a.25.25,0,0,0,.25.25Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }